// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"_2wXs_","miniAudioPlayerContainer":"_1GOiK"};